import type { QueryClient } from '@tanstack/react-query'
import type { DashboardStreamEvent } from '@/lib/dashboardStream'

/**
 * Table occupancy/positions are read under two query keys across the app:
 *   - ['tables']          — counter + server floor views
 *   - ['tables-summary']  — admin Table Management
 * Both hit the same GET /tables. Invalidating only one leaves the other stale,
 * which is how "another terminal paid but my floor still shows occupied" slips
 * through. Always invalidate both together via this helper.
 *
 * Counter also keeps ['counterPendingOrders'] (Open Orders strip) in sync with
 * these events — see CounterInterface handleTableStream. Do not refresh tables
 * alone on the counter without the strip (OPEN_ORDERS_STRIP_HIDDEN_2026-07-23).
 */
export function invalidateTables(qc: QueryClient) {
  qc.invalidateQueries({ queryKey: ['tables'] })
  qc.invalidateQueries({ queryKey: ['tables-summary'] })
}

/** SSE event types that can change a table's occupancy on another terminal. */
export function isTableAffectingEvent(ev: DashboardStreamEvent): boolean {
  return (
    ev.type === 'table_status_changed' ||
    ev.type === 'table_changed' ||
    ev.type === 'order_created' ||
    ev.type === 'order_completed' ||
    ev.type === 'order_cancelled' ||
    ev.type === 'order_voided' ||
    ev.type === 'payment'
  )
}
